import React, { useEffect, useState } from 'react';
import './inventory-count.styles.scss';
import { format } from 'date-fns';

const ManageInventoryCount = ({
  saveData,
  formData,
  setAlertMessage,
  gameStats
}) => {
  const [addAmount, setAddAmount] = useState('');
  const [claimedAmount, setClaimedAmount] = useState(0);

  const log = formData?.opt_inventoryLog ?? [];
  const totalAdded = log.reduce((sum, entry) => sum + entry.amount, 0);

  useEffect(() => {
    if (!gameStats) return;
    // '_purchased' tags a subset of '_earned' rather than being a separate
    // bucket, so only '_earned' counts against inventory
    let total = 0;
    if (gameStats[formData.id + '_earned']) {
      total += gameStats[formData.id + '_earned'];
    }
    setClaimedAmount(total);
  }, [gameStats])

  function handleAdd() {
    const amount = Number(addAmount);
    if (!addAmount || !Number.isInteger(amount) || amount === 0) {
      setAlertMessage('Please enter a whole number. Use a negative number to remove stock.');
      return;
    }
    saveData('opt_inventoryLog', [...log, { amount, ts: new Date().getTime() }]);
    setAddAmount('');
  }

  return (
    <div className='manage-inventory-count g-list-item form-section'>
      <h3>Real World Item Inventory<span className='required'>*</span></h3>
      <hr />
      <p>Add to the inventory whenever new stock becomes available. Enter a negative number to remove stock (damaged, lost, or handed out offline). Each entry is recorded with a timestamp.</p>
      <div className='field small inline'>
        <input
          type='number'
          className='short-input'
          placeholder='Qty +/-'
          value={addAmount}
          step={1}
          onChange={(e) => setAddAmount(e.target.value)}
        />
        <button
          type='button'
          className='g-button small-btn'
          onClick={handleAdd}>
          Add
        </button>
      </div>

      <div className='inventory-history'>
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Added</th>
            </tr>
          </thead>
          <tbody>
            {
              (log.length > 0)
                ?
                log.map((entry, i) => (
                  <tr key={i}>
                    <td>{format(new Date(entry.ts), 'MMM d, yyyy')}</td>
                    <td className={`amount-col ${entry.amount < 0 ? 'removed' : ''}`}>
                      {entry.amount > 0 ? '+' : ''}{entry.amount}
                    </td>
                  </tr>
                ))
                :
                <tr>
                  <td colSpan={2}>No inventory additions recorded yet.</td>
                </tr>
            }
            <tr>
              <td className='amount-col claimed'><b>Total Claimed:</b></td>
              <td className='amount-col claimed'>-{claimedAmount}</td>
            </tr>

            <tr className='inventory-summary'>
              <td>Total Available</td>
              <td>{totalAdded - claimedAmount}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="g-space-1"></div>
    </div>
  )
}

export default ManageInventoryCount
